<template>
	<v-card class="text-xs-left">
		<v-toolbar flat dense cad>
			<v-toolbar-title class="subheading">Comments</v-toolbar-title>
		</v-toolbar>
		<v-divider></v-divider>
        <v-layout row class="pa-3">
			<v-flex shrink class="mr-3">
				<v-avatar size="36px">
					<img :src="getAvatar(loggedInEmployee.id)" alt="avatar" class="avatar-img" />
				</v-avatar>
			</v-flex>
			<v-flex>
				<v-textarea
					:readonly="isSavingComment"
					class="comment-textarea"
					v-model="newComment"
					solo
					label="Add Comment..."
					rows="3"
					row-height="20"
					auto-grow
					:error-messages="newCommentErrors"
					required
				></v-textarea>
				<v-btn style="float: right; margin: 4px 0px 0px 0px" small @click="saveComment" color="primary" :loading="isSavingComment" :disabled="isSavingComment">
					Add Comment
					<span slot="loader">Adding...</span>
				</v-btn>
			</v-flex>
		</v-layout>
        	<v-divider></v-divider>
		<div v-for="comment in commentsSorted" :key="comment.id">
			<v-layout row class="pa-3" :class="{ 'deleting-comment': comment.id === deletingCommentId }">
				<v-flex shrink class="mr-3">
					<v-tooltip bottom>
						<v-avatar size="36px" slot="activator">
							<img :src="getAvatar(comment.author.id)" alt="avatar" class="avatar-img" />
						</v-avatar>
						<span>{{ comment.author.fullName }}</span>
					</v-tooltip>
				</v-flex>
				<v-flex>
					<div class="comment-text" v-html="comment.text"></div>
					<div class="comment-date">
						<AppDate :date="comment.createdDateUTC" />
					</div>
				</v-flex>
				<v-flex shrink>
					<v-icon v-if="loggedInEmployee.id === comment.author.id && comment.id !== deletingCommentId" small class="mr-2" @click="deleteComment(comment)" title="Delete Comment">
						delete
					</v-icon>
				</v-flex>
			</v-layout>
			<v-divider :key="`divider${comment.id}`"></v-divider>
		</div>
	
	</v-card>
</template>

<script>
	import avatarMixin from '@/mixins/avatarMixin';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			comments: {
				type: Array,
				required: true
			},
			loggedInEmployee: {
				type: Object,
				required: true
			},
			isSavingComment: {
				type: Boolean,
				required: false
			},
			deletingCommentId: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				newComment: ''
			};
		},
		mixins: [avatarMixin, validationMixin],
		validations: {
			newComment: { required }
		},
		computed: {
			newCommentErrors() {
				const errors = [];
				if (!this.$v.newComment.$dirty) return errors;
				!this.$v.newComment.required && errors.push('Comment cannot be empty.');
				return errors;
            },
            commentsSorted() {
                return this.comments.sort((a, b) => new Date(b.createdDateUTC) - new Date(a.createdDateUTC));
            }
		},
		methods: {
			resetForm() {
				this.$v.newComment.$reset();
				this.newComment = '';
			},
			saveComment() {
				this.$v.newComment.$touch();

				if (this.$v.newComment.$invalid) {
					console.log('invalid form');
				} else {
					var comment = {
						id: this.newGuid(),
						text: this.newComment,
						author: this.loggedInEmployee
					};

					this.$emit('onSave', comment);
				}
			},
			deleteComment(comment) {
				if (confirm('Are you sure you wish to delete this comment?')) {
					this.$emit('onDelete', comment);
				}	
			}
		}
	};
</script>

<style scoped>
	.comment-text {
		text-align: left;
		white-space: pre-line;
	}
	.comment-date {
		text-align: left;
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}
	.deleting-comment {
		opacity: 0.3;
	}
</style>